export default {"src":"/_next/static/media/footer_facebook.bc4af7f8.svg","height":18,"width":11,"blurWidth":0,"blurHeight":0};